import React from "react";
import { Link } from "react-router-dom";
import { Lock, ArrowLeft, Clock } from "lucide-react";
import Chevron from "@/components/Chevron";
import { useT } from "@/i18n/LanguageProvider";

export default function Login() {
  const t = useT();
  return (
    <section
      className="relative bg-delfi-dark text-white flex items-center justify-center px-6 overflow-hidden pt-36 pb-24 min-h-[calc(100vh-260px)]"
      data-testid="login-page"
    >
      <div className="chevron-bg right-[-10%] top-[-18%] opacity-[0.08]" aria-hidden="true">›</div>
      <div className="absolute inset-0 grid-pattern opacity-40" aria-hidden="true" />
      <div className="hero-glow left-[-200px] top-[-180px]" aria-hidden="true" />
      <div className="hero-glow right-[-260px] bottom-[-260px] opacity-70" aria-hidden="true" />

      <div className="relative z-10 max-w-lg w-full text-center">
        <div className="inline-flex items-center gap-2 text-delfi-cloud text-xs tracking-[0.2em] uppercase font-semibold justify-center">
          <Chevron size={14} color="#F5E9E2" /> {t.login.eyebrow}
        </div>
        <div className="mt-6 inline-flex w-20 h-20 rounded-2xl bg-white/5 border border-white/10 text-delfi-red items-center justify-center">
          <Lock size={30} />
        </div>
        <h1 className="headline-display text-white mt-6 text-[clamp(2rem,5vw,3.2rem)]" data-testid="login-title">
          {t.login.title}
        </h1>
        <p className="mt-5 text-white/70 leading-relaxed">{t.login.body}</p>
        <div className="mt-8 inline-flex items-center gap-2 text-sm text-white/60">
          <Clock size={14} /> {t.login.note}
        </div>
        <div className="mt-10 flex flex-wrap gap-3 justify-center">
          <Link to="/" className="btn-delfi-ghost" data-testid="login-back-home">
            <ArrowLeft size={16} /> {t.common.backHome}
          </Link>
          <Link to="/partner" className="btn-delfi-primary" data-testid="login-partner-cta">
            {t.common.becomePartner}
          </Link>
        </div>
      </div>
    </section>
  );
}
